import { render, staticRenderFns } from "./Ep1.vue?vue&type=template&id=4c185b50&scoped=true&"
import script from "./Ep1.vue?vue&type=script&lang=ts&"
export * from "./Ep1.vue?vue&type=script&lang=ts&"
import style0 from "./Ep1.vue?vue&type=style&index=0&id=4c185b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c185b50",
  null
  
)

export default component.exports